import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './serviceCard.css';
import { gsap } from 'gsap';

import { useSelectedServices } from '../../Sections/ServicesSection/SelectedServicesContext';
import { useBottomSheet } from '../../Modals/BottomSheet/BottomSheetContext';

const cardsData = [
];

const getCategories = (cardsData) => {
  const categories = [];
  cardsData.forEach((card) => {
    if (!categories.includes(card.text.split(' ')[0])) {
      categories.push(card.text.split(' ')[0]);
    }
  });
  return categories;
};

const Card = React.forwardRef(function Card({
  imageSrc,
  additionalImageSrc,
  text,
  pill,
  description,
  onClick,
}, ref) {
  const cardRef = useRef(null);

  const { selectedServices } = useSelectedServices();
  const { setIsOpen, setCurrentService } = useBottomSheet();
  const isSelected = selectedServices.includes(text);

  const handleCardClick = (e) => {
    e.stopPropagation();
    setCurrentService({ imageSrc, additionalImageSrc, text, description });
    setIsOpen(true);
    if (onClick) onClick({ imageSrc, additionalImageSrc, text, description });
  };

  const handleMouseEnter = () => {
    gsap.to(cardRef.current, {
      scale: 1.05,
      duration: 0.3,
      ease: 'power2.out',
    });
  };

  const handleMouseLeave = () => {
    gsap.to(cardRef.current, {
      scale: 1,
      duration: 0.3,
      ease: 'power2.out',
    });
  };

  return (
    <div
      ref={cardRef}
      className={`card-container ${isSelected ? 'selected' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleCardClick}
    >
      <img src={imageSrc} alt="Card" className="card-image" />
      {additionalImageSrc && <img src={additionalImageSrc} alt="Additional" className="additional-image" />}
      <div className="service-title-wrapper">
        {getCategories(cardsData).map((category) => (
          <p key={category}>{category}</p>
        ))}
        {/* {pill && (
          <div className="pill">
            <p className="pill-text">{pill}</p>
          </div>
        )} */}
        <h6 className="card-title">{text}</h6>
      </div>
    </div>
  );
});

Card.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  additionalImageSrc: PropTypes.string,
  text: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default Card;
